import { Box } from "@mui/material"
import { useSelector } from "react-redux"
import PatientsTable from "./PatientsTable"

const DisplayPatients = () => {
  const centerId = useSelector(({ center }) => center)?.data?.id

  return (
    <Box mt={4} sx={{ minWidth: "100%" }}>
      {centerId && <PatientsTable centerId={centerId} />}
    </Box>
  )
}

export default DisplayPatients